/**
 * Created by ricardocabret on 8/30/16.
 */
angular.module('googleAnalytics.factory', [
    // Global localytics factory
])

    .factory('GA', [function () {
        return {
            trackPageView: function (url) {
                if (!ga) {
                    return;
                }
                ga('set', 'page', url);
                ga('send', 'pageview');
            },
            trackEvent: function (category, action, label, value) {
                if (!ga) {
                    return;
                }
                ga('send', 'event', category, action, label, value);
            }
        }
    }]);